import { Report } from '../types/report.type';

export namespace ReportsMapper {
  export function fromBackend(report: Report) {
    report.sum = report.sum / 100;
    return report;
  }
}
